const Transaction = {
  path: "",
  name: "",
  redirect: "/report/transaction",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/report/transaction",
      redirect: "/report/transaction",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Transaction",
      meta: {
        requiresAuth: true,
        activeUrl: "/report/transaction",
        parent: "/report/transaction",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/report/transaction"),
          meta: {
            requiresAuth: true,
            activeUrl: "/report/transaction",
            parent: "/report/transaction",

            lv: 2,
          },
        },
        {
          path: ":id",
          name: "Transaction Detail",
          component: () =>
            import("@/views/pages/report/transaction/detail/detail"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/report/transaction",
            parent: "/report/transaction",

            lv: 3,
          },
        },
        {
          path: "/transaction/configdata",
          name: "Config Data",
          component: () =>
            import("@/views/pages/transaction/import/configField.vue"),
          meta: {
            requiresAuth: true,

            activeUrl: "/report/transaction",
            parent: "/report/transaction",
            lv: 3,
          },
        },
        {
          path: "/transaction/importdata",
          name: "Import Data",
          component: () =>
            import("@/views/pages/transaction/import/ImportFile.vue"),
          meta: {
            requiresAuth: true,

            activeUrl: "/report/transaction",
            parent: "/report/transaction",
          },
        },
        {
          path: "/transaction/checkfield",
          name: "Transaction Check Data",
          component: () =>
            import("@/views/pages/transaction/import/checkField.vue"),
          meta: {
            requiresAuth: true,

            activeUrl: "/report/transaction",
            parent: "/report/transaction",
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default Transaction;
